module.exports = __webpack_public_path__ + "static/media/clients-01.ffc6388b.svg";